import { serializable, alias, list, object, primitive } from 'serializr';
import { Address } from 'models/Address/address.model';

// Distance-based travel entry (air, car, rail)
export class DistanceBasedTravel {
  @serializable
  id?: number;

  @serializable(alias('travel_mode', primitive()))
  travelMode?: string | null = null; // 'air', 'car', 'rail'

  @serializable(alias('origin', primitive()))
  origin?: string | null = null;

  @serializable(alias('destination', primitive()))
  destination?: string | null = null;

  // Address objects for location modal (not serialized to backend)
  originAddress?: Address | null = null;
  destinationAddress?: Address | null = null;

  @serializable(alias('round_trip', primitive()))
  roundTrip?: boolean | null = false;

  @serializable(alias('number_of_passengers', primitive()))
  numberOfPassengers?: number | null = 1; // Default: 1

  @serializable(alias('car_size', primitive()))
  carSize?: string | null = null; // 'small', 'medium', 'large', 'average'

  @serializable(alias('car_type', primitive()))
  carType?: string | null = null; // 'petrol', 'diesel', 'hybrid', 'plugin_hybrid', 'battery', 'average'

  @serializable(alias('flight_class', primitive()))
  flightClass?: string | null = null; // 'economy', 'premium_economy', 'business', 'first', 'average'
}

// Spend-based travel entry
export class SpendBasedTravel {
  @serializable
  id?: number;

  @serializable(alias('spend_type', primitive()))
  spendType?: string | null = null; // 'air', 'road', 'rail', 'sea', 'hotel'

  @serializable(alias('money', primitive()))
  money?: number | null = null;

  @serializable(alias('money_unit', primitive()))
  moneyUnit?: string | null = null; // Currency code (e.g., 'usd', 'eur', 'cad')

  @serializable(alias('spend_location', primitive()))
  spendLocation?: string | null = null;

  // Address object for location modal (not serialized to backend)
  spendLocationAddress?: Address | null = null;
}

// Hotel stay entry
export class HotelStay {
  @serializable
  id?: number;

  @serializable(alias('hotel_nights', primitive()))
  hotelNights?: number | null = null;

  @serializable(alias('location', primitive()))
  location?: string | null = null;

  // Address object for location modal (not serialized to backend)
  locationAddress?: Address | null = null;
}

// Main Business Travel data model
export class BusinessTravelData {
  @serializable(alias('distance_based_travel', list(object(DistanceBasedTravel))))
  distanceBasedTravel?: DistanceBasedTravel[];

  @serializable(alias('spend_based_travel', list(object(SpendBasedTravel))))
  spendBasedTravel?: SpendBasedTravel[];

  @serializable(alias('hotel_stays', list(object(HotelStay))))
  hotelStays?: HotelStay[];
}
